import { SectionHeader, EmptyState, Button, Icon } from "../../components/Elements";
import { MiniSwitch } from "../../components/MiniSwitch.jsx";
import { useQnaPage } from "./useQnaPage.js";
import { MessageText } from "../../constants/constants.js";

const QNA_ICON = "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z";

// embedded: rendered inside the MainPage accordion (hides this page's own SectionHeader).
// filter: "all" | "active" | "inactive" - applied by the ControlTabs radio filter.
export default function Qna({ embedded = false, filter = "all" } = {}) {
  const { qna, qnaToggle, activeCount, totalCount, isReady } = useQnaPage();
  if (!isReady) return null;
  const visible =
    filter === "all" ? qna : qna.filter((q) => (filter === "active" ? q.isApproved === true : q.isApproved !== true));

  return (
    <div className="w-full max-w-4xl">
      {!embedded && (
      <SectionHeader
        title="Q&A Management"
        icon={QNA_ICON}
        description="Enable a question to show it in the viewer Q&A section"
        badge={`${activeCount}/${totalCount} active`}
      />
      )}

      {qna.length === 0 && <EmptyState icon={QNA_ICON} title={MessageText.emptyQna.title} description={MessageText.emptyQna.description} />}

      {qna.length > 0 && visible.length === 0 && (
        <p className="text-xs text-gray-400 text-center py-6">No {filter} questions</p>
      )}
      {/* Compact rows sized like the viewer Q&A panel (clir-rj-cme-core/src/components/qnaPanel):
          p-3, rounded-lg, text-sm. Status dot + question on the left, Active switch on the right. */}
      <div className="space-y-2">
        {visible.map((q) => (
          <div
            key={q.id}
            className={`w-full max-w-xl flex items-start gap-3 p-3 rounded-lg bg-white border ${q.isApproved ? "border-gray-400" : "border-gray-200"}`}
          >
            <span
              className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${q.isApproved ? "bg-emerald-500" : "bg-gray-300"}`}
              title={q.isApproved ? "Active" : "Inactive"}
              aria-hidden="true"
            />
            <p className="flex-1 min-w-0 text-sm text-gray-800 break-words">
              {q.question || "No question set"}
              {q.id != null && (
                <span
                  className="ml-1.5 inline-block text-[10px] font-mono font-semibold px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 tabular-nums align-middle"
                  title="Question ID"
                >
                  ID {String(q.id)}
                </span>
              )}
            </p>
            <div className="shrink-0">
              <MiniSwitch checked={q.isApproved} onChange={(v) => qnaToggle(q.id, v)} label="Active" hint="Show this question to viewers" />
            </div>
          </div>
        ))}
      </div>
      {/* <div className="mt-8 pt-6 border-t border-gray-200">
        <Button
          variant="danger"
          size="md"
          aria-label="Clear all questions"
          onClick={() => {
            if (window.confirm('Clear all Q&A? This will instantly remove all active questions from viewers and clear history for new joiners.')) {
              clearQnaChannel?.();
            }
          }}
        >
          <Icon name="trash" className="w-4 h-4 mr-2" /> Clear All Q&A
        </Button>
        <p className="text-xs text-gray-500 mt-2">Removes active questions for live viewers and clears history for new joiners.</p>
      </div> */}
    </div>
  );
}
